import cyberpunk from "../../../apis/cyberpunk"
import { RESET_CACHES } from "../../user/redux/reducers"

// Grid duck — The Grid cross-cell feed. Mirrors the pattern used in
// components/cell/redux. Action types are namespaced cyberpunk-media/.

const FETCH_GRID = "cyberpunk-media/FETCH_GRID"
const FETCH_GRID_MORE = "cyberpunk-media/FETCH_GRID_MORE"
const FETCH_TRENDING = "cyberpunk-media/FETCH_TRENDING"
const IS_LOADING = "cyberpunk-media/GRID_IS_LOADING"
const IS_LOADING_MORE = "cyberpunk-media/GRID_IS_LOADING_MORE"
const ERROR = "cyberpunk-media/GRID_ERROR"

const INITIAL_STATE = {
  posts: [],
  page: 1,
  total: 0,
  hasMore: false,
  cells: [],
  trending: [],
  // True once the feed has been fetched — navigation back to /grid then
  // reuses the store instead of refetching (manual Refresh available).
  loaded: false,
  isLoading: false,
  isLoadingMore: false,
  isError: false,
  errorMessage: null
}

export const gridReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case FETCH_GRID:
      return {
        ...state,
        posts: action.payload.posts,
        page: action.payload.page,
        total: action.payload.total,
        hasMore: action.payload.hasMore,
        cells: action.payload.cells,
        loaded: true,
        isLoading: false,
        isError: false
      }
    case FETCH_GRID_MORE:
      return {
        ...state,
        posts: [...state.posts, ...action.payload.posts],
        page: action.payload.page,
        total: action.payload.total,
        hasMore: action.payload.hasMore,
        cells: action.payload.cells,
        isLoadingMore: false,
        isError: false
      }
    case FETCH_TRENDING:
      return { ...state, trending: action.payload }
    case IS_LOADING:
      return { ...state, isLoading: action.status }
    case IS_LOADING_MORE:
      return { ...state, isLoadingMore: action.status }
    case RESET_CACHES:
      return INITIAL_STATE
    case ERROR:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        isLoading: false,
        isLoadingMore: false
      }
    default:
      return state
  }
}

const authHeader = () => {
  const token = JSON.parse(localStorage.getItem("jwt") || "null")
  const value = (token && token.token) || "noToken"
  cyberpunk.defaults.headers.common = { Authorization: `bearer ${value}` }
}

const to = promise => promise.then(data => [null, data]).catch(err => [err])

export const fetchGridPosts = (page = 1, limit = 20) => async dispatch => {
  dispatch({ type: page === 1 ? IS_LOADING : IS_LOADING_MORE, status: true })
  authHeader()
  const [err, response] = await to(
    cyberpunk.get(`/grid/posts?page=${page}&limit=${limit}`)
  )
  if (err) {
    const message =
      (err.response && err.response.data && err.response.data.error) || err.message
    dispatch({ type: ERROR, payload: message })
  } else {
    dispatch({
      type: page === 1 ? FETCH_GRID : FETCH_GRID_MORE,
      payload: response.data
    })
  }
}

export const fetchTrendingCells = () => async dispatch => {
  authHeader()
  const [err, response] = await to(cyberpunk.get("/cells/trending"))
  if (err) {
    // Trending is a side rail — swallow errors rather than blanking the feed.
    return
  }
  dispatch({
    type: FETCH_TRENDING,
    payload: (response.data && response.data.trending) || []
  })
}
